const headerVariant = 'links-developer-dropdown-menu-header-new';

export default {
  headerVariant
};
